/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type change_requests_AllergyChangeField = {
    allergy_id?: string;
    comment?: string;
    name?: string;
    operation?: change_requests_AllergyChangeField.operation;
    severity?: change_requests_AllergyChangeField.severity;
};
export namespace change_requests_AllergyChangeField {
    export enum operation {
        ADD = 'add',
        UPDATE = 'update',
        REMOVE = 'remove',
    }
    export enum severity {
        MILD = 'MILD',
        MODERATE = 'MODERATE',
        SEVERE = 'SEVERE',
    }
}

